import UNIQUE from '@/common/unique'

export default {
  id: 'instagramfeed',
  name: 'instagramfeed',
  type: 'standard',
  moduleName: 'editor_module_instagramfeed',
  dataSet: {
    mods: 'instagramfeed',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'instagramfeed',
        detail: {
          options: ['instagramfeed']
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'background',
        'border',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
